import { Avatar, Box, makeStyles } from '@material-ui/core'
import React from 'react'
import CustomLabel from './CustomLabel'

const useStyles = makeStyles((theme) => ({
  image: {
    width: '32px',
    height: '32px',
    [theme.breakpoints.up('md')]: {
      //
    },
    [theme.breakpoints.up('lg')]: {
      // '&:hover': {
      //   width: '62px',
      //   height: '62px',
      // },
    },
  },
}))

export default function User({ label, image }) {
  const classes = useStyles()
  return (
    <Box display="flex">
      <Avatar alt={label} src={image} className={classes.image} />
      <div style={{ margin: 'auto 0px auto 10px' }}>
        <CustomLabel label={label} />
      </div>
    </Box>
  )
}
